import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { actions as cedipActions } from "reducers/cedip";
import * as i18n from "util/i18n";

export const useTags = (optionCedip) => {
    const dispatch = useDispatch();
    const [tags, setTags] = useState([]);
    const { cedipFilters } = useSelector((state) => state.cedip);

    const commonTagOptions = {
        createdFrom: { id: "createdRange", text: i18n.get("cedips.createdRange.label") },
        expiredFrom: { id: "expiredRange", text: i18n.get("cedips.expiredRange.label") },
        status: { id: "status", text: i18n.get("cedips.status.label") },
    };

    const tagOptions = {
        "cedip.list": {
            ...commonTagOptions,
            // receiver: { id: "receiver", text: i18n.get("echecks.receiver.label") },
        },
        "cedip.received": {
            ...commonTagOptions,
            // emitted: { id: "emitted", text: i18n.get("echecks.emitted.label") },
        },
        "cedip.transmited": {
            ...commonTagOptions,
            // emitted: { id: "emitted", text: i18n.get("echecks.emitted.label") },
        },
    };

    useEffect(() => {
        const activeTags = Object.entries(cedipFilters)
            .filter(
                (activeFilters) =>
                    !activeFilters.includes("") && !activeFilters.includes("TODOS") && !activeFilters.includes(null),
            )
            .map((filter) => filter[0])
            .filter((filterKey) => !!tagOptions[optionCedip][filterKey])
            .map((key) => tagOptions[optionCedip][key]);

        setTags(activeTags);
    }, [cedipFilters]);

    const handleDelete = (i) => {
        const deletedFilter = tags.find((tag, index) => index === i).id;

        if (deletedFilter !== "createdRange" && deletedFilter !== "expiredRange" && deletedFilter !== "status") {
            const tagFilters = {
                ...cedipFilters,
                [deletedFilter]: "",
            };
            dispatch(cedipActions.setCedipFilters(tagFilters));
            dispatch(cedipActions.filterCedipList(tagFilters));
            return;
        }

        if (deletedFilter === "createdRange") {
            const tagFilters = {
                ...cedipFilters,
                createdFrom: null,
                createdTo: null,
            };
            dispatch(cedipActions.setCedipFilters(tagFilters));
            dispatch(cedipActions.filterCedipList(tagFilters));
            return;
        }

        if (deletedFilter === "expiredRange") {
            const tagFilters = {
                ...cedipFilters,
                expiredFrom: null,
                expiredTo: null,
            };
            dispatch(cedipActions.setCedipFilters(tagFilters));
            dispatch(cedipActions.filterCedipList(tagFilters));
            return;
        }

        if (deletedFilter === "status") {
            const tagFilters = {
                ...cedipFilters,
                status: "TODOS",
            };
            dispatch(cedipActions.setCedipFilters(tagFilters));
            dispatch(cedipActions.filterCedipList(tagFilters));
        }
    };

    const handleCleanFilters = () => {
        const clearFilters = {
            ...cedipFilters,
            createdFrom: null,
            createdTo: null,
            expiredFrom: null,
            expiredTo: null,
        };
        dispatch(cedipActions.setCedipFilters(clearFilters));
        dispatch(cedipActions.filterCedipList(clearFilters));
    };

    return { tags, handleDelete, handleCleanFilters };
};

export default useTags;
